module.exports = __webpack_public_path__ + "img/TruPath-3.1eb5b230.jpg";